__webpack_require__.p = "/services/laser-hair-removal/";